import { Group, Clock } from 'three'
export default class BaseHierarchicalObject extends Group {
  constructor () {
    super()
    this._parent = null
    this.timer = new Clock()
    this.lastTime = 0
    this.name = 'BaseHierarchicalObject'
    this._children = []
  }
  update (timeStamp) {
    if (this.lastTime === 0) { this.lastTime = timeStamp }
    this.delta = (timeStamp - this.lastTime) / 1000
    this.lastTime = timeStamp

    for (var child of this._children) {
      child.update(timeStamp)
    }
  }
  addChild (child) {
    this._children.push(child)
    this.add(child)
    child._parent = this
  }
  removeChild (child) {
    this._children = this._children.filter(function (el) {
      return el !== child
    })
    this.remove(child)
  }
}
